import FrontCoverArea from "./front_cover";
import ContentPageArea from "./content_page";

function WritePageArea(props: any) {
  let myProps = {
    info: {},
    setInfo: (inInfo: any) => { },
    is_write_mode: false,
    printRef: null,
    ...props
  };
  let info = myProps.info;
  let is_write_mode = myProps.is_write_mode;

  return (
    <div className="a4page" ref={myProps.printRef} style={{padding:0}}>
      <FrontCoverArea {...myProps} />
      <ContentPageArea {...myProps} />
    </div>
  );
};
export default WritePageArea;